module.exports = __webpack_public_path__ + "static/media/indent-decrease.7444b84c.svg";